import { useState, useCallback } from 'react';

export const useInvoiceForm = (initialData = null) => {
  const [formData, setFormData] = useState(initialData);
  const [submitting, setSubmitting] = useState(false);

  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }, []);

  const handleItemChange = useCallback((index, field, value) => {
    setFormData(prev => {
      const updatedItems = [...prev.items];
      updatedItems[index] = {
        ...updatedItems[index],
        [field]: field === 'quantity' || field === 'unit_price' || field === 'tax_rate' || field === 'tax_amount' || field === 'total_price' 
          ? parseFloat(value) || 0 
          : value
      };
      
      // Recalculate values when quantity, unit price or tax rate changes
      if (field === 'quantity' || field === 'unit_price') {
        const netTotal = updatedItems[index].quantity * updatedItems[index].unit_price;
        const taxRate = updatedItems[index].tax_rate || 0;
        const taxAmount = (netTotal * taxRate) / 100;
        
        updatedItems[index].total_price = netTotal;
        updatedItems[index].tax_amount = taxAmount;
      }
      
      if (field === 'tax_rate') {
        const netTotal = updatedItems[index].quantity * updatedItems[index].unit_price;
        updatedItems[index].tax_amount = (netTotal * updatedItems[index].tax_rate) / 100;
      }

      return {
        ...prev,
        items: updatedItems
      };
    });
  }, []);

  const addItem = useCallback(() => {
    const newItem = {
      description: '',
      product_code: '',
      quantity: 1,
      unit_price: 0,
      tax_rate: 20,
      tax_amount: 0,
      total_price: 0,
      unit_of_measure: ''
    };
    
    setFormData(prev => ({
      ...prev,
      items: [...(prev.items || []), newItem]
    }));
  }, []);

  const removeItem = useCallback((index) => {
    setFormData(prev => ({
      ...prev,
      items: prev.items.filter((_, i) => i !== index)
    }));
  }, []);

  const updateFormData = useCallback((updates) => {
    setFormData(prev => ({
      ...prev,
      ...updates
    }));
  }, []);

  return {
    formData,
    setFormData,
    submitting,
    setSubmitting,
    handleInputChange,
    handleItemChange,
    addItem,
    removeItem,
    updateFormData
  };
};